import React from 'react';
import { useTranslation } from 'react-i18next'
import { Add, Copy, Down, Edit, Remove, Up, View } from '../../../components/Icons/Icons';
import { Tooltip } from "../../../components/Utils/Tooltips";

const DeletePractitioner = ({ deletePractitioner, userId }) => {
    const { t } = useTranslation();

    return (
        <Tooltip tooltip={t("protocols.groups.actionDeletePractitioner")}>
            <button className="btn-remove btn-table-actions" onClick={() => deletePractitioner(userId)}>
                <Remove />
            </button>
        </Tooltip>

    );
};

export default DeletePractitioner;